export default "__VITE_ASSET__Djz9Kqvw__"